import React from "react";
import { ModalUnderConstruction } from "components";

export const TncSubModal: React.FunctionComponent = () => {
  return (
    <ModalUnderConstruction subtext="The terms & conditions page is coming soon..." />
  );
};
